<template>
  <div class="producto w-100">
    <div class="contenedor-producto" v-for="(item,index) in DetalleProducto" :key="index">
      <div class="portada-portafolio shadow">
        <div
          class="subportada-portafolio d-flex align-items-center justify-content-center flex-wrap"
        >
          <div>
            <h1 variant="blanco" class="w-100">{{item.nombre}}</h1>
          </div>
        </div>
      </div>
      <div class="texto-producto row w-100 mx-auto pt-5 pb-4 justify-content-center">
        <div class="contenedor-img-producto col-12">
          <titulo-seccion>La mejor solución para administrar tu empresa</titulo-seccion>
        </div>
        <div class="col-12 text-center pt-3">
          <p class="mb-0 px-lg-5">
            Administra tu empresa con el ERP más completo del mercado para automatizar procesos como gestión de inventario,
            nómina, facturación, recursos humanos, cuentas por cobrar y más, para mejorar la toma de decisiones de la
            empresa aumentando todos los beneficios.
          </p>
        </div>
      </div>
    </div>
    <div class="contenido">
      <div>
        <div class="row w-100 mx-auto justify-content-center">
          <div class="col-12 pb-4">
            <titulo-seccion class="pb-3">Soluciones empresariales</titulo-seccion>
            <p
              class="mb-0 px-lg-5 pb-1"
            >Descubre increíbles soluciones para hacer crecer pequeñas y grandes empresas.</p>
          </div>
          <div class="contenedor-texto col-12 col-md-6 my-2">
            <div>
              <h2>Gestión Financiera</h2>
              <p>Optimiza todos los procedimientos de la nómina y contabilidad.</p>
            </div>
          </div>
          <div class="contenedor-img col-12 col-md-6 my-2">
            <img
              class="shadow"
              src="@/assets/images/productos/domit/soluciones_generales/gestion_financiera.jpeg"
              width="100%"
              height="100%"
            />
          </div>
          <div class="contenedor-img col-12 col-md-6 my-2">
            <img
              class="shadow"
              src="@/assets/images/productos/domit/soluciones_generales/gestion_comercial.jpeg"
              width="100%"
              height="100%"
            />
          </div>
          <div class="contenedor-texto col-12 col-md-6 my-2">
            <div>
              <h2>Gestión Comercial</h2>
              <p>Controla los pagos, cobros pendientes y cotizaciones.</p>
            </div>
          </div>

          <div class="contenedor-texto col-12 col-md-6 my-2">
            <div>
              <h2>Gestión Humana</h2>
              <p>Optimiza la gestión de recursos humanos y aumenta la productividad de tu empresa.</p>
            </div>
          </div>
          <div class="contenedor-img col-12 col-md-6 my-2">
            <img
              class="shadow"
              src="@/assets/images/productos/domit/soluciones_generales/gestion_humana.jpeg"
              width="100%"
              height="100%"
            />
          </div>
          <div class="contenedor-img col-12 col-md-6 my-2">
            <img
              class="shadow"
              src="@/assets/images/productos/domit/soluciones_generales/gestion_operativa.jpeg"
              width="100%"
              height="100%"
            />
          </div>
          <div class="contenedor-texto col-12 col-md-6 my-2">
            <div>
              <h2>Gestión Operativa</h2>
              <p>Gestiona y realiza reportes automáticos de las operaciones en la empresa.</p>
            </div>
          </div>

          <div class="col-12 py-3">
            <titulo-seccion class="py-3">Descubre sus características principales</titulo-seccion>
            <p class="mb-0 px-lg-5 pb-1">
              Nuestro sistema está capacitado con una amplia cantidad de características para mejorar todos los procesos de tu
              empresa.
            </p>
          </div>
          <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-3">
            <div class="contenedor-icono">
              <i class="fas fa-city"></i>
            </div>
            <h3 class="mt-3 mb-1">Multiempresa</h3>
            <p>Permite trabajar con diversas empresas, sin mezcla errónea de datos almacenando la información por separado.</p>
          </div>

          <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-3">
            <div class="contenedor-icono">
              <i class="fas fa-building"></i>
            </div>
            <h3 class="mt-3 mb-1">Sucursales</h3>
            <p>
              Realiza las tareas de cada sucursal de manera independiente, en una misma base de datos con vista
              organizada de todas las operaciones.
            </p>
          </div>

          <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-3">
            <div class="contenedor-icono">
              <i class="fas fa-boxes"></i>
            </div>
            <h3 class="mt-3 mb-1">Multialmacenes</h3>
            <p>Maneja varios almacenes en una misma empresa, existencia en valor de los productos y su cantidad en cada almacén.</p>
          </div>

          <div class="contenedor-caracteristica col-12 col-md-6 col-lg-4 p-2">
            <div class="contenedor-icono">
              <i class="fas fa-users"></i>
            </div>
            <h3 class="mt-3 mb-1">Multiusuario</h3>
            <p>Puede ser usado simultáneamente por varios usuarios mediante diferentes ordenadores.</p>
          </div>
        </div>
      </div>
      <!-- --------------------------------------------------------------------------------------------------------------------------------- -->
      <div class="pt-3 pb-5 row w-100 mx-auto">
        <div class="col-12">
          <titulo-seccion>¡Soluciones para todos los sectores comerciales!</titulo-seccion>
          <p
            class="pb-2 pt-3"
          >Elige el sector comercial al que pertenece tu empresa y descubre como SOFKIA hará prosperar tus negocios.</p>
        </div>
        <div class="contenedor-img col-12 col-md-6 my-3 my-lg-2">
          <img
            class="shadow"
            src="@/assets/images/productos/domit/retail.jpeg"
            width="100%"
            height="100%"
            title="Retail"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-3 my-lg-2">
          <div>
            <h2>ADG Retail</h2>
            <p>
              La mejor solución para administrar boutiques, supermercados, zapaterías, perfumerías, joyerías, tiendas
              especializadas y peluquerías.
            </p>
            <boton-enlace to="/sectores/retail">Descubrir</boton-enlace>
          </div>
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-3 my-lg-2">
          <div>
            <h2>ADG Hostelería</h2>
            <p>
              La mejor solución para administrar
              restaurantes, pizzerías, fast food, cafeterías, discotecas, catering o colectividades.
            </p>
            <boton-enlace to="/sectores/hosteleria">Descubrir</boton-enlace>
          </div>
        </div>
        <div class="contenedor-img col-12 col-md-6 my-3 my-lg-2">
          <img
            class="shadow"
            src="@/assets/images/productos/domit/hosteleria.jpeg"
            width="100%"
            height="100%"
            title="Hostelería"
          />
        </div>

        <div class="contenedor-img col-12 col-md-6 my-3 my-lg-2">
          <img
            class="shadow"
            src="@/assets/images/productos/domit/industrias.jpeg"
            width="100%"
            height="100%"
            title="Industrias"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-3 my-lg-2">
          <div>
            <h2>ADG Industrias</h2>
            <p>La mejor solución para administrar importadoras, mayoristas, ferreterías o distribuidoras.</p>
            <boton-enlace to="/sectores/industrias">Descubrir</boton-enlace>
          </div>
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-3 my-lg-2">
          <div>
            <h2>ADG Salud</h2>
            <p>La mejor solución para gestionar centros de salud.</p>
            <boton-enlace to="/sectores/salud">Descubrir</boton-enlace>
          </div>
        </div>

        <div class="contenedor-img col-12 col-md-6 my-3 my-lg-2">
          <img
            class="shadow"
            src="@/assets/images/productos/domit/salud.jpeg"
            width="100%"
            height="100%"
            title="Salud"
          />
        </div>

        <div class="contenedor-img col-12 col-md-6 my-3 my-lg-2">
          <img
            class="shadow"
            src="@/assets/images/productos/domit/hoteles.jpeg"
            width="100%"
            height="100%"
            title="Hoteles"
          />
        </div>
        <div class="contenedor-texto col-12 col-md-6 my-3 my-lg-2">
          <div>
            <h2>ADG Hoteles</h2>
            <p>La mejor solución para gestionar hoteles y aparta hoteles.</p>
            <boton-enlace to="/sectores/hoteles">Descubrir</boton-enlace>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "product",
  components: {},
  data() {
    return {
      DetalleProducto: []
    };
  },
  computed: {
    ...mapState(["Productos"])
  },
  created() {
    this.producto();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    producto() {
      this.Productos.forEach(item => {
        if (item.id == 1) {
          this.DetalleProducto.push(item);
        }
      });
    }
  }
};
</script>
<style scoped>
/* Portada */
.portada-portafolio {
  height: 60vh;
  width: 100%;
  color: white;
  background: #262626;
  background: url("../../../assets/images/productos/domit/domit_portada.jpeg");
  background-size: cover;
}
.portada-portafolio h1 {
  font-size: calc(3.5em + 1vw);
  font-weight: bold;
  letter-spacing: -0.5px;
}
.portada-portafolio h1 {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
.subportada-portafolio {
  background: rgba(0, 0, 0, 0.23);
  height: 100%;
  width: 100%;
}
.contenido,
.texto-producto {
  padding: 0 6%;
}
.contenedor-producto p,
.contenido p,
.contenedor-caracteristica p {
  font-size: calc(0.9em + 0.3vw);
  color: #595959;
}
@media screen and (max-width: 768px) {
  .contenedor-producto p,
  .contenido p,
  .contenedor-caracteristica p {
    font-size: calc(1em + 0.3vw);
    color: #595959;
  }
  .portada-portafolio h1 {
    font-size: calc(2.8em + 1vw);
  }
}
/* Fin Portada */
/* Contenido */
.contenedor-texto {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.contenedor-icono {
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.15);
  width: 100px;
  margin: auto;
  height: 100px;
  border-radius: 200px;
  color: #262626;
  border: 4px solid #262626;
  font-size: 3.1em;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Fin Contenido */
</style>
